import { Box } from '@mui/material';
import type { LayoutProps } from 'react-admin';
import {
  AppBar, CheckForApplicationUpdate, Layout as RALayout, TitlePortal,
} from 'react-admin';
import { Link } from 'react-router-dom';

import SideMenu from './Navigation/SideMenu';

function SterlingLogo() {
  return (
    <Box
      component={Link}
      to='/'
      sx={{
        display: 'flex',
        alignItems: 'center',
        marginRight: 2,
        textDecoration: 'none',
      }}
    >
      <img
        src='/sterling-sound-logo-light.svg'
        alt='Sterling Sound'
        height={28}
        width='auto'
        style={{ display: 'block' }}
      />
    </Box>
  );
}

function DarkAppBar() {
  return (
    <AppBar
      sx={{
        'backgroundColor': '#1B1D1F',
        'color': '#FFFFFF',
        'boxShadow': '0 4px 6px -1px rgba(0, 0, 0, 0.2)',
        'borderBottom': '1px solid #0F0F10',
        '& .RaAppBar-menuButton': { color: '#FFFFFF' },
        '& .RaAppBar-toolbar': { backgroundColor: '#1B1D1F', color: '#FFFFFF' },
      }}
    >
      <SterlingLogo />
      <TitlePortal />
    </AppBar>
  );
}

export function Layout(props: LayoutProps) {
  return (
    <>
      {/* <RALayout {...props} appBar={YellowAppBar} /> */}
      <RALayout
        {...props} appBar={DarkAppBar}
        menu={SideMenu}
      />
      <CheckForApplicationUpdate />
    </>
  );
}
